import * as React from "react";
import type { SVGProps } from "react";

/**
 * Recommend Icon - 推荐/点赞图标
 * Used for: Recommend category
 */
const RecommendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={21}
    viewBox="0 0 48 48"
    {...props}
    fill={"currentColor"}
    fillRule={"evenodd"}
  >
    <path d="M40.737 22.987s2.5.692 2.5 2.854c0 2.6-2.854 3.211-2.854 3.211a3.4 3.4 0 0 1 1.784 2.854 3.487 3.487 0 0 1-2.5 3.211 2.307 2.307 0 0 1 1.784 2.5c0 1.876-2.15 2.5-3.568 2.5h-15.7a14.311 14.311 0 0 1-6.422-2.141V21.2s6.157-5.826 7.136-8.563a60.612 60.612 0 0 0 1.784-6.779c.345-1.253 2.927-1.256 3.925 0a10.261 10.261 0 0 1 .357 10.7H40.38a3.767 3.767 0 0 1 2.854 3.211c0 2.12-2.497 3.218-2.497 3.218ZM10.766 40.113H6.841A2.141 2.141 0 0 1 4.7 37.972V21.916a2.141 2.141 0 0 1 2.141-2.14h3.925a2.141 2.141 0 0 1 2.141 2.14v16.056a2.141 2.141 0 0 1-2.141 2.141Z" />
  </svg>
);

export default RecommendIcon;

